import React, { useState, useEffect } from 'react';
import { useAuth } from '../../AuthContext';
import { Grid } from '@mui/material';
import { Link, useNavigate, useLocation } from 'react-router-dom'; // Replace useHistory with useNavigate
import { startSilentRefresh,logout } from './tokenManager';
import {api} from './axiosConfig';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';
import GoogleSignInDark from './web_dark_rd_ctn@4x.png'
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Snackbar,
  IconButton,
  InputAdornment,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Alert
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Footer2 from '../Footer/Footer2';
import CircularProgress from '@mui/material/CircularProgress';



const styles = {
  glassBox: {
    backdropFilter: 'blur(15px)',
    backgroundColor: '#1111',
    borderRadius: '16px',
    padding: '1.5rem',
    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.2)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    maxWidth: '400px',
    textAlign: 'center',
    '&:hover': {
      borderColor: '#1E90FF',
    },
  },
  logo: {
    width: '450px',
    height: 'auto',
    objectFit: 'contain',
  },
  logoBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  slogan: {
    marginTop: '8px',
    fontSize: '1.2rem',
    color: '#FFFFF0',
  },
  text: {
    letterSpacing: 2,
    color: 'white',
    '&:hover': {
      color: '#1E90FF',
    },
  },
  root: {
    letterSpacing: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
  input: {
    letterSpacing: 2,
    marginBottom: '1rem',
    '& .MuiInputBase-input': {
      color: 'white',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.7)',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.5)',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1E90FF',
    },
  },
  button: {
    backgroundColor: '#1E90FF',
    color: 'white',
    marginTop: '1rem',
  },
  iconButton: {
    margin: '0.5rem 0',
    color: 'white',
    borderColor: 'rgba(255, 255, 255, 0.5)',
    '&:hover': {
      borderColor: 'white',
    },
  },
  link: {
    color: '#1E90FF',
    letterSpacing: 2,
    textDecoration: 'none',
    '&:hover': {
      color: '#1E90FF',
    },
  },
};

const API_URL = process.env.REACT_APP_API_URL;

const Login = ({ onLogin }) => {

  const { login } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [forgotPasswordDialogOpen, setForgotPasswordDialogOpen] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [loginError, setLoginError] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingSeconds, setLoadingSeconds] = useState(0);
  const redirect = new URLSearchParams(location.search).get('redirect') || '';

  useEffect(() => {
          let timer;
        
          if (loading) {
            setLoadingSeconds(0); // reset timer
            timer = setInterval(() => {
              setLoadingSeconds(prev => prev + 1);
            }, 1000);
          } else {
            clearInterval(timer);
            setLoadingSeconds(0); // optional reset after done
          }
        
          return () => clearInterval(timer); // cleanup on unmount or loading = false
        }, [loading]);


  // Load user data from localStorage if "Remember Me" is checked
  // useEffect(() => {
  //   if (localStorage.getItem('rememberMe') === 'true') {
  //     const savedUsername = localStorage.getItem('username');
  //     const savedPassword = localStorage.getItem('password');
  //     setUsername(savedUsername);
  //     setPassword(savedPassword);
  //     setRememberMe(true);
  //   }
  // }, []);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

//   const handleLogin = async () => {
//   setLoading(true); // Start loading
//   try {
//     setLoginError(''); // Clear previous errors

//     const response = await axios.post(`${API_URL}/api/token/`, { email, password });

//     const { access, refresh, user_id, role, roles } = response.data;

//     localStorage.setItem('access_token', access);
//     localStorage.setItem('refresh_token', refresh);
//     localStorage.setItem('user_id', user_id);
//     localStorage.setItem('role', role);
//     localStorage.setItem('roles', roles);
//     startSilentRefresh(); // ✅ ADD HERE
//     // localStorage.setItem('roles', JSON.stringify(roles)); // Convert array to string


//     login(user_id, role);

//     const from = location.state?.from?.pathname || '/';
//     navigate(from, { replace: true });

//     // const redirectTo = new URLSearchParams(location.search).get('redirect');
//     // navigate(redirectTo || '/', { replace: true });
//   } catch (err) {
//     console.error('Login failed:', err.response?.data);
//     if (err.response?.status === 401) {
//       setLoginError('Invalid email or password.');
//     } else {
//       setLoginError('An unexpected error occurred. Please try again.');
//     }
//   } finally {
//     setLoading(false); // Stop loading
//   }
// };
const handleLogin = async () => {
  setLoading(true);
  try {
    setLoginError('');
    const response = await api.post('/api/token/', { email, password });
    const { access, refresh, user_id, role, roles } = response.data;

    localStorage.setItem('access_token', access);
    localStorage.setItem('refresh_token', refresh);

    login(user_id, role, roles); // AuthContext handles user_id/user_role/user_roles storage
    navigate(location.state?.from?.pathname || '/chatbot', { replace: true });
  } catch (err) {
    setLoginError(
      err.response?.status === 401
        ? 'Invalid email or password.'
        : 'An unexpected error occurred. Please try again.'
    );
  } finally {
    setLoading(false);
  }
};


const handleGoogleLoginSuccess = (response) => {
  setLoading(true); // Start loading
  setLoginError(''); // Clear previous errors

  api.post(`${API_URL}/api/auth/google/`, { token: response.credential })
    .then((res) => {
      const { access, refresh, user_id, role, roles } = res.data;

      // Store tokens and user info in localStorage
      localStorage.setItem('access_token', access);
      localStorage.setItem('refresh_token', refresh);
      localStorage.setItem('user_id', user_id);
      localStorage.setItem('role', role);
      localStorage.setItem('roles', roles);
      startSilentRefresh(); // ✅ ADD HERE

      // Call login method
      login(user_id, role);

      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });

      // Redirect after login
      // const redirectTo = new URLSearchParams(location.search).get('redirect');
      // navigate(redirectTo || '/', { replace: true });
    })
    .catch((err) => {
      console.error('Google Login failed:', err.response?.data);
      if (err.response?.status === 401) {
        setLoginError('Google authentication failed.');
      } else {
        setLoginError('An unexpected error occurred during Google login.');
      }
    })
    .finally(() => {
      setLoading(false); // Stop loading
    });
};


const handleLinkedInLogin = () => {

  const clientId = "866fmnrsqwbwlq";

  const redirectUri =
    "https://www.anthrasync.com/linkedin/callback"

  const scope = "openid profile email";

  const state = Math.random()
    .toString(36)
    .substring(2);

  localStorage.setItem(
    "linkedin_oauth_state",
    state
  );

  const linkedinAuthUrl =
    `https://www.linkedin.com/oauth/v2/authorization` +
    `?response_type=code` +
    `&client_id=${clientId}` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&scope=${encodeURIComponent(scope)}` +
    `&state=${state}`;

  window.location.href = linkedinAuthUrl;
};


  const handleGoogleLoginFailure = (error) => {
    setErrorMessage('Google Login failed');
    setSnackbarOpen(true);
  };

  const handleForgotPassword = async () => {
  setLoading(true); // Start loading
  try {
    const response = await api.post(`${API_URL}/forgot-password/`, { email: forgotPasswordEmail });
    setForgotPasswordDialogOpen(false);
    alert('Password reset link sent to your email.');
  } catch (error) {
    setErrorMessage('Error sending reset link');
    setSnackbarOpen(true);
  } finally {
    setLoading(false); // Stop loading
  }
};


  return (
    <div>
      <GoogleOAuthProvider clientId="726356221679-98ltpc47jvkau98j9rc0l2jige7lu1dv.apps.googleusercontent.com">
        <Container maxWidth="lg" sx={styles.root}>
          <Grid container spacing={2}>
            {/* Left Side: Logo and Slogan */}
            <Grid
              item
              xs={12}
              sm={6}
              className="logoBox"
              sx={{
                ...styles.logoBox,
                textAlign: { xs: 'center', sm: 'left' }, // Center the content on small screens, left-align on larger screens
                padding: { xs: '1rem', sm: '2rem' }, // Add responsive padding for better spacing
                display: 'flex',
                flexDirection: 'column', // Stack logo and slogan vertically on small screens
                alignItems: 'center', // Center-align elements on small screens
                justifyContent: 'center', // Vertically center the items
              }}
            >
              <Link to="/home">
                <img
                  src={Logo}
                  alt="Logo"
                  style={{
                    ...styles.logo,
                    width: '100%', // Ensure the logo scales with the container width
                    maxWidth: '500px', // Limit the logo size for larger screens
                  }}
                />
              </Link>
              <Typography
                variant="h6"
                component="h1"
                sx={{
                  ...styles.slogan,
                  marginTop: { xs: '1rem', sm: '0.5rem' }, // Add spacing between logo and slogan on small screens
                  fontSize: { xs: '1rem', sm: '1.25rem' }, // Adjust the font size for better readability
                  textAlign: 'center',
                  letterSpacing: 3,
                }}
              >
                Unlocking Potential Through Knowledge
              </Typography>
            </Grid>


            {/* Right Side: Login Box */}
            <Grid item xs={12} sm={6} container justifyContent="center" alignItems="center">
              {loginError && (
                <Alert
                  severity="error"
                  variant="filled"
                  onClose={() => setLoginError('')}
                  sx={{
                    mb: 3,
                    backgroundColor: 'rgba(255, 0, 0, 0.85)',
                    color: 'white',
                    fontWeight: 'bold',
                    letterSpacing: 1,
                    textAlign: 'center',
                    borderRadius: 2,
                  }}
                >
                  {loginError}
                </Alert>
              )}
              <Box sx={styles.glassBox}>
                <Typography variant="h6" sx={{ color: 'white', fontSize: '25px', '&:hover': { color: '#1E90FF' }, letterSpacing: 5, }}>
                  Login
                </Typography>

                <TextField
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  label="Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value)
                    setLoginError('');
                  }
                  }
                  sx={{
                    ...styles.input,
                    '& .MuiInputBase-input': {
                      letterSpacing: 2, // Adjust the value as needed
                    },
                  }}
                />

                <TextField
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  label="Password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value)
                    setLoginError('');
                  }}
                  sx={{
                    ...styles.input,
                    '& .MuiInputBase-input': {
                      letterSpacing: '0.1em', // Adjust the value as needed
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <Visibility sx={{ color: 'black' }} /> : <VisibilityOff sx={{ color: 'black' }} />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                {/* <FormControlLabel
                  control={<Checkbox checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} sx={{ color: 'white' }} />}
                  label={<Typography sx={styles.text}>Remember me</Typography>}
                /> */}

                <Button
                  variant="contained"
                  sx={styles.button}
                  fullWidth
                  onClick={handleLogin}
                >
                  Login
                </Button>

                <Button
                  variant="text"
                  onClick={() => setForgotPasswordDialogOpen(true)}
                  sx={{
                    color: '#1E90FF',
                    marginTop: '1rem',
                    letterSpacing: 3,
                  }}
                >
                  <Typography sx={{ ...styles.text, fontSize: '0.7rem', letterSpacing: 3, }}>
                    Forgot Password?
                  </Typography>
                </Button>

                <Box my={2}>
                  <Typography variant="body2" sx={styles.text}>or</Typography>
                </Box>

                <GoogleLogin
                  onSuccess={handleGoogleLoginSuccess}
                  onError={handleGoogleLoginFailure}
                  useOneTap
                  size="large"
                  theme="dark"  // Dark theme for Google button
                  shape="rectangular"
                  text="signin_with"
                  width="100%" // Make the button full width
                  style={{
                    borderRadius: '4px',

                    padding: '10px 0',  // Optional: Add padding for better appearance
                  }}
                />
                <Button
  variant="contained"
  fullWidth
  onClick={handleLinkedInLogin}
  sx={{
    mt: 2,
    backgroundColor: '#0A66C2',
    color: 'white',
    '&:hover': {
      backgroundColor: '#004182',
    },
  }}
>
  Continue with LinkedIn
</Button>

                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
                  {/* <Typography variant="body2" sx={styles.text}>
                    You will be able to create an account and start using the platform shortly.
                  </Typography> */}
                  <Typography variant="body2" sx={styles.text}>
                    Don't have an account?
                  </Typography>
                  <Link to={`/signup${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`} style={{ ...styles.link, marginLeft: '8px', letterSpacing: 3, }}>
                    Create account
                  </Link>
                </Box>

              </Box>
            </Grid>
          </Grid>

          <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            message={errorMessage}
            action={
              <IconButton size="small" aria-label="close" color="inherit" onClick={() => setSnackbarOpen(false)}>
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          />

          {/* Forgot Password Dialog */}
          <Dialog
            open={forgotPasswordDialogOpen}
            onClose={() => setForgotPasswordDialogOpen(false)}
            maxWidth="sm"
            fullWidth
            sx={{
              '& .MuiDialog-paper': {
                backgroundColor: '#000000',
                color: 'white',
                borderRadius: '8px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
                padding: '2rem',
              },
            }}
          >
            <DialogTitle
              sx={{
                color: 'white',
                fontSize: '1.4rem',
                fontWeight: 'bold',
                marginBottom: '1rem',
                letterSpacing: 3,
              }}
            >
              Reset Password
            </DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                label="Enter your email"
                value={forgotPasswordEmail}
                onChange={(e) => setForgotPasswordEmail(e.target.value)}
                sx={{
                  backgroundColor: '#1111',
                  letterSpacing: 3,
                  input: {
                    color: 'white',
                  },
                  label: {
                    color: 'rgba(255, 255, 255, 0.7)',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'rgba(255, 255, 255, 0.3)',
                    },
                    '&:hover fieldset': {
                      borderColor: '#1E90FF',
                    },
                  },
                }}
              />
            </DialogContent>
            <DialogActions
              sx={{
                backgroundColor: '#1111',
                letterSpacing: 2,
                borderTop: '1px solid rgba(255, 255, 255, 0.2)',
                padding: '1rem',
              }}
            >
              <Button
                onClick={() => setForgotPasswordDialogOpen(false)}
                color="primary"
                sx={{
                  color: 'white',
                  letterSpacing: 3,
                  '&:hover': {
                    backgroundColor: '#1111',
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleForgotPassword}
                color="primary"
                sx={{
                  letterSpacing: 3,
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#1E90FF',
                  },
                }}
              >
                Send Reset Link
              </Button>
            </DialogActions>
          </Dialog>

          {loading && (
                                        <Box
                                          sx={{
                                            position: 'fixed',
                                            top: 0,
                                            left: 0,
                                            width: '100vw',
                                            height: '100vh',
                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                            zIndex: 2000,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backdropFilter: 'blur(3px)',
                                          }}
                                        >
                                          <Box sx={{ textAlign: 'center' }}>
                                            <CircularProgress
                                size={60}
                                thickness={6}
                                sx={{
                                  color: 'transparent',
                                  '& .MuiCircularProgress-circle': {
                                    stroke: 'url(#better-gradient)',
                                  },
                                }}
                              />
                              
                              <svg width="0" height="0">
                                <defs>
                                  <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stopColor="#f30b96ff" />     {/* pinkish-purple */}
                                    <stop offset="50%" stopColor="#221ce0ff" />     {/* deep lavender */}
                                    <stop offset="100%" stopColor="#0eacebff" />    {/* bright sky blue */}
                                  </linearGradient>
                                </defs>
                              </svg>
                              
                                            <Typography
                                              variant="h6"
                                              sx={{
                                                mt: 2,
                                                color: '#fff',
                                                textShadow: '0 1px 3px rgba(0,0,0,0.7)',
                                              }}
                                            >
                                              Loading Platform... ({loadingSeconds} sec)
                                            </Typography>
                                          </Box>
                                        </Box>
                                      )}

        </Container>
      </GoogleOAuthProvider>
      <Footer2 />
    </div>
  );
};

export default Login;



